import "./src/styles/global.css";

export const shouldUpdateScroll = () => false;
